const mutations = {
  SET_SELECTED_DATA_FROM_SPED(state, selectedDataFromSped) {
    state.notesFromDB = selectedDataFromSped;
  },
  SET_EXPANDED_NOTE({ notesFromDB }, { idNfe }) {
    notesFromDB.tBody.forEach((item) => {
      if (item.idNfe !== idNfe && item.expanded) item.expanded = false;
      if (item.idNfe !== idNfe) return;
      item.expanded = !item.expanded;
    });
  },
  SET_ITENS_FROM_XML(state, seletedItensFromXML) {
    const isOnState = state.itensFromXML.find(
      (item) => item.idNf === seletedItensFromXML.idNf,
    );
    if (isOnState) return;
    state.itensFromXML.push(seletedItensFromXML);
  },
  REMOVE_REFERENCE({ itensFromXML }, itemInfo) {
    const { idNfe, xProd, cProd } = itemInfo;
    const [
      {
        itens: { tBody },
      },
    ] = itensFromXML.filter((item) => item.idNf === idNfe);
    const itens = tBody.filter(
      (item) => item.xProd === xProd && item.cProd === cProd,
    );
    const cells = itens.flatMap((item) => item.cells);

    itens.forEach((item) => {
      item.referenced = !item.referenced;
      if (!item.referenced) {
        item.pDifalApured = 0;
        item.vBcDifalApured = 0;
        item.vDifalApured = 0;
      }
    });

    cells.forEach((cell) => {
      if (!["pDifal", "vBcDifal", "vDifal", "reference"].includes(cell.name))
        return;
      if (["pDifal", "vBcDifal", "vDifal"].includes(cell.name)) {
        cell.value = 0;
        return;
      }
      cell.value = !cell.value;
    });
  },
  SET_ITEM_TO_REFERENCING({ itensFromXML }, { idNfe, xProd, cProd }) {
    const [
      {
        itens: { tBody },
      },
    ] = itensFromXML.filter((item) => item.idNf === idNfe);
    const items = tBody.filter(
      (item) => item.xProd === xProd && item.cProd === cProd,
    );
    items.forEach((item) => {
      item.isReferencing = !item.isReferencing;
    });
  },
  SET_VL_APURATION_ON_ITEMS({ itensFromXML }, { idNfe, apuration }) {
    const [
      {
        itens: { tBody },
      },
    ] = itensFromXML.filter((item) => item.idNf === idNfe);
    const apurationObj = {};
    if (apuration) {
      apuration.forEach((item) => {
        apurationObj[item.idItem] = {
          pDifal: item.pDifal,
          vBcDifal: item.vBcDifal,
          vDifal: item.vDifal,
        };
      });
    }

    tBody.forEach((item) => {
      if (!apurationObj.hasOwnProperty(item.idItem)) return;
      const { pDifal, vBcDifal, vDifal } = apurationObj[item.idItem];
      item.pDifalApured = pDifal;
      item.vBcDifalApured = vBcDifal;
      item.vDifalApured = vDifal;
      item.cells.forEach((cell) => {
        if (cell.name === "pDifal") cell.value = pDifal;
        if (cell.name === "vBcDifal") cell.value = vBcDifal;
        if (cell.name === "vDifal") cell.value = vDifal;
      });
    });
  },
  SET_VL_APURATION_ON_NF({ notesFromDB }, { idNfe, totalNote }) {
    const [{ cells }] = notesFromDB.tBody.filter(
      (item) => item.idNfe === idNfe,
    );
    cells.forEach((item) => {
      if (item.name === "pDifalApurado") item.value = totalNote.pDifal;
      if (item.name === "vBcDifalApurado") item.value = totalNote.vBcDifal;
      if (item.name === "vDifalApurado") item.value = totalNote.vDifal;
    });
  },
  SET_NOTE_TO_CALCULATING({ notesFromDB, itensFromXML }, { idNfe, xProd }) {
    const [note] = notesFromDB.tBody.filter((item) => item.idNfe === idNfe);
    const [
      {
        itens: { tBody },
      },
    ] = itensFromXML.filter((item) => item.idNf === idNfe);
    const calculatingItems = tBody.filter((item) => item.xProd === xProd);
    calculatingItems.forEach((item) => {
      item.isCalculating = !item.isCalculating;
    });
    note.isCalculating = !note.isCalculating;
  },
  SET_SELECTED_NOTE(state, selectedNote) {
    state.selectedNote = selectedNote;
  },
  GET_KEYS(state) {
    return state.keys;
  },
  SET_KEYS(state, keys) {
    state.keys = keys;
  },
  SET_TOTAL_APURATION(state, { apuration }) {
    if (apuration)
      state.totalDifalApured = apuration.reduce(
        (acc, el) => acc + parseFloat(el.vDifal),
        0,
      );
  },
};

export default mutations;
